import ThreeByOneWidgetPlayer, {
  ThreeByOneWidgetPlayerProps,
} from './ThreeByOneWidgetPlayer';

export default ThreeByOneWidgetPlayer;
export type { ThreeByOneWidgetPlayerProps };
